export default "__VITE_ASSET__30052ed4__"